// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

class EventsPeople extends React.Component {
	render() {
		const { page, people } = this.props
		const eventConferenceSlug = page && page.conference ? page.conference : ''
		let markup

		if ( people && Object.keys( people ).length ) {
			markup = Object.keys( people ).map( key => {
				let item = people[ key ]

				if ( item.conference !== eventConferenceSlug ) {
					return
				}

				return (
					<div className="-person" key={ key }>
						<div className="-image">
							<img
								src={ item.image.url }
								srcSet={ item.image.srcset }
								sizes={ `(max-width: ${siteData.mobile_max_width}) 50vw, 400px` }
								alt={ item.image.alt }
							/>
						</div>

						<div className="-text">
							<h3 className="-name">{ item.name }</h3>

							<div className="-content"  dangerouslySetInnerHTML={ { __html: item.content } } />
						</div>
					</div>
				)
			} )
		}

		if ( ! markup ) {
			return null
		}

		return (
			<div className="events-people">
				{ markup }

				<div className="-info">
					<p>
						If you would like further information about these events, please contact your local ATSIM Director.
					</p>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected,
		people: state.site.people
	}
}

export default connect( mapStateToProps )( EventsPeople )



// WEBPACK FOOTER //
// ./views/page/EventsPeople.jsx